import { GENERAL_SECTION } from "../fields";

const SECTION_CATALOG = [
    {
        key: "specification",
        label: "Specification",
        description:
            "The test listing, with its limits and method references. Usually the specification or the protocol.",
    },
    {
        key: "protocol",
        label: "Test Schedule (Protocol)",
        description: "The test schedule and its notes.",
    },
    {
        key: "report",
        label: "Study Results (Report)",
        description:
            "The study tables — results, batch headers, abbreviations. The protocol commonly belongs here too: the schedule is in the protocol, but batch identity and a conditional rule's alert level are often stated only in the report.",
    },
    {
        key: "container",
        label: "Container Closure System",
        description: "The container-closure system and the proposed shelf life.",
    },
];

const SECTIONS = SECTION_CATALOG.map((s) => s.key);

const STEPS = [{ key: "details", title: "Configure" }];

const BLOCK_TITLES = {
    "general:study": "The study",
    "general:protocol": "The protocol",
};

const BLOCK_DESCRIPTIONS = {
    "general:study":
        "The study's own attributes. Every one of these changes the generated document, so an unrecognised name here is rejected outright rather than quietly ignored.",
};

const FIELD_DEFINITIONS = {
    product_names: {
        block: "study",
        label: "Product Name(s)",
        type: "string_list",
        description:
            "The products the study covers. The engine labels the rendered tables with them.",
        required: true,
    },
    test_conditions: {
        block: "study",
        label: "Test Conditions",
        type: "string_list",
        description: 'The storage conditions under test, e.g. "25°C/60%RH".',
        required: true,
    },
    purpose_of_study: {
        block: "study",
        label: "Purpose of Study",
        type: "long_text",
        description:
            "The study's scope statement, a paragraph, rendered into the document near-verbatim — write it as it should read there.",
        required: true,
    },
    addition_tests: {
        block: "study",
        label: "Additional Tests",
        type: "string_list",
        description: "Tests beyond those the specification lists. Empty means none.",
    },
    product_type: {
        block: "protocol",
        label: "Submission Type",
        type: "text",
        description:
            'Specify how the regulatory filing should be referenced in the generated text, e.g. "This variation contains stability data...". Common values: Supplement, Submission, Application, Amendment, Variation.',
        required: true,
    },
    company_name: {
        block: "protocol",
        label: "Company Name",
        type: "text",
        description: "The sponsor. No client document names its own sponsor.",
        required: true,
    },
    extension_of_expiration_statement: {
        block: "protocol",
        label: "Extension of Expiration Dating Period",
        type: "long_text",
        description:
            "The extension-of-expiration commitment. Becomes its own section — leave it blank and that section is not rendered at all.",
    },
};

const stabilityTemplate = (id, fieldNames) => ({
    id,
    steps: STEPS,
    sectionCatalog: SECTION_CATALOG,
    fields: fieldNames.map((name) => ({
        section: GENERAL_SECTION,
        group: "p8_stability",
        name,
        ...FIELD_DEFINITIONS[name],
    })),
    blockTitles: BLOCK_TITLES,
    blockSections: {},
    blockDescriptions: BLOCK_DESCRIPTIONS,
    sectionArticleType: {},
    sectionsWithoutDocuments: new Set(),
    optionalSections: new Set(["container"]),
    orderedSectionKey: null,
    nonMetadataKeys: new Set(),
    fixedSections: SECTIONS,
    payloadTables: ["p8_stability"],
    emitsDeviceFamily: false,
    hasArticles: false,
    advisories: null,
});

export const p8StabilitySummary = stabilityTemplate("p8_stability_summary", ["product_names"]);

export const p8StabilityProtocol = stabilityTemplate("p8_stability_protocol", [
    "product_names",
    "test_conditions",
    "product_type",
    "company_name",
    "extension_of_expiration_statement",
]);

export const p8StabilityData = stabilityTemplate("p8_stability_data", [
    "product_names",
    "test_conditions",
    "purpose_of_study",
    "addition_tests",
]);
